import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Address: any;
  BigDecimal: any;
  DateTime: any;
  Long: any;
  Uint256: any;
  Url: any;
  _FieldSet: any;
};

export type CleanPayload = {
  __typename?: 'CleanPayload';
  hasClean?: Maybe<Scalars['Boolean']>;
};

export enum ErrorCode {
  NameNotAvailable = 'NameNotAvailable',
  NameTaken = 'NameTaken',
  NameTooLong = 'NameTooLong',
  NameTooShort = 'NameTooShort'
}

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

export enum EventType {
  Igov2Deposit = 'IGOV2_DEPOSIT',
  MoleTransfer = 'MOLE_TRANSFER'
}

export type FeedFoodInput = {
  foodType: FoodType;
  owner: Scalars['Address'];
  tokenIds: Array<Scalars['Int']>;
};

export type FeedFoodPayload = {
  __typename?: 'FeedFoodPayload';
  acceptFood?: Maybe<Scalars['Boolean']>;
};

export enum FoodType {
  Broccoli = 'BROCCOLI',
  Fries = 'FRIES'
}

export type GachaDetails = {
  __typename?: 'GachaDetails';
  endTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
};

export enum GachaOption {
  Exp = 'EXP',
  Hp = 'HP'
}

export type GainMoleDashExpInput = {
  lifespan: Scalars['Long'];
  owner: Scalars['Address'];
};

export type GainMoleDashExpPayload = {
  __typename?: 'GainMoleDashExpPayload';
  gainedExp?: Maybe<Scalars['BigDecimal']>;
};

export type IBaseError = {
  code: ErrorCode;
  message: Scalars['String'];
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  moles?: Maybe<MoleConnection>;
};


export type LeaderboardMolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter: LeaderboardFilterInput;
  first: Scalars['Int'];
};

export type LeaderboardFilterInput = {
  rarity: Rarity;
};

export type LockedMole = {
  __typename?: 'LockedMole';
  tokenId?: Maybe<Scalars['Int']>;
  unlockAt?: Maybe<Scalars['DateTime']>;
};

export type LoginInput = {
  address: Scalars['Address'];
  signature: Scalars['String'];
  timestamp: Scalars['Long'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  accessToken: Scalars['String'];
  address: Scalars['Address'];
  /**  epoch second */
  expiresAt?: Maybe<Scalars['Long']>;
  refreshToken: Scalars['String'];
};

export type Mole = {
  __typename?: 'Mole';
  boost?: Maybe<Scalars['BigDecimal']>;
  hasFedToday?: Maybe<Scalars['Boolean']>;
  health?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['Url']>;
  isEnlisted?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  isStaked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['Address']>;
  rank?: Maybe<Scalars['Int']>;
  rarity?: Maybe<Rarity>;
  tier?: Maybe<Scalars['Int']>;
  tokenId: Scalars['Int'];
  totalExp?: Maybe<Scalars['BigDecimal']>;
  unlockAt?: Maybe<Scalars['DateTime']>;
};

export type MoleConnection = {
  __typename?: 'MoleConnection';
  edges: Array<MoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Long'];
};

export type MoleDashRecord = {
  __typename?: 'MoleDashRecord';
  completedAt?: Maybe<Scalars['DateTime']>;
  lifespan?: Maybe<Scalars['Long']>;
  owner?: Maybe<Scalars['Address']>;
};

export type MoleEdge = {
  __typename?: 'MoleEdge';
  cursor: Scalars['String'];
  node: Mole;
};

export type MoleFilterInput = {
  enlisted?: Array<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  clean: CleanPayload;
  feedFood: FeedFoodPayload;
  gainMoleDashExp: GainMoleDashExpPayload;
  login: LoginPayload;
  redeemGacha: RedeemGachaPayload;
  refreshToken: RefreshTokenPayload;
  rerunBlock?: Maybe<Scalars['Boolean']>;
  updateMole: UpdateMolePayload;
  updateTeamMembers: UpdateTeamMembersPayload;
};


export type MutationCleanArgs = {
  address: Scalars['Address'];
};


export type MutationFeedFoodArgs = {
  input: FeedFoodInput;
};


export type MutationGainMoleDashExpArgs = {
  input: GainMoleDashExpInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRedeemGachaArgs = {
  address: Scalars['Address'];
  type: GachaOption;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRerunBlockArgs = {
  blocks: Array<Scalars['Long']>;
  key?: InputMaybe<Scalars['String']>;
  types: Array<EventType>;
};


export type MutationUpdateMoleArgs = {
  input: UpdateMoleInput;
};


export type MutationUpdateTeamMembersArgs = {
  input: UpdateTeamMembersInput;
};

export type NameNotAvailable = IBaseError & {
  __typename?: 'NameNotAvailable';
  code: ErrorCode;
  message: Scalars['String'];
};

export type NameTooLong = IBaseError & {
  __typename?: 'NameTooLong';
  code: ErrorCode;
  message: Scalars['String'];
};

export type NameTooShort = IBaseError & {
  __typename?: 'NameTooShort';
  code: ErrorCode;
  message: Scalars['String'];
};

export type Owner = {
  __typename?: 'Owner';
  address: Scalars['Address'];
  expMultiplier?: Maybe<Scalars['Float']>;
  gachaInfo?: Maybe<OwnerGachaInfo>;
  /** @deprecated Use gachaInfo#gachaRecordCount instead */
  gachaRecordCount?: Maybe<Scalars['Int']>;
  hasAdopted?: Maybe<Scalars['Boolean']>;
  highestDailyExp?: Maybe<Scalars['BigDecimal']>;
  isClean?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use gachaInfo#isGachaEligible instead */
  isGachaEligible?: Maybe<Scalars['Boolean']>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use gachaInfo#isTeamFedToday instead */
  isTeamFedToday?: Maybe<Scalars['Boolean']>;
  lockedMoles: Array<LockedMole>;
  moleDashInfo?: Maybe<OwnerMoleDashInfo>;
  /** sort by tokenId */
  moles?: Maybe<Array<Maybe<Mole>>>;
  nextDirtyDeclineTime?: Maybe<Scalars['DateTime']>;
  /** sort by descending time */
  questHistory?: Maybe<OwnerQuestHistory>;
  quests?: Maybe<Array<OwnerQuest>>;
  teamHealthPoint?: Maybe<Scalars['Int']>;
  todayExp?: Maybe<Scalars['BigDecimal']>;
  todayQuestCount?: Maybe<Scalars['Int']>;
};


export type OwnerMolesArgs = {
  filter?: InputMaybe<MoleFilterInput>;
};

export type OwnerGachaInfo = {
  __typename?: 'OwnerGachaInfo';
  gachaRecordCount?: Maybe<Scalars['Int']>;
  isGachaEligible?: Maybe<Scalars['Boolean']>;
  isTeamFedToday?: Maybe<Scalars['Boolean']>;
  todayDifferentQuestCount?: Maybe<Scalars['Int']>;
};

export type OwnerMoleDashInfo = {
  __typename?: 'OwnerMoleDashInfo';
  bestRecord?: Maybe<MoleDashRecord>;
  todayExp?: Maybe<Scalars['BigDecimal']>;
};

export type OwnerQuest = {
  __typename?: 'OwnerQuest';
  exp?: Maybe<Scalars['BigDecimal']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  symbol: Symbol;
};

export type OwnerQuestHistory = {
  __typename?: 'OwnerQuestHistory';
  questHistoryConnection?: Maybe<QuestHistoryConnection>;
  totalEarnedExp?: Maybe<Scalars['BigDecimal']>;
};


export type OwnerQuestHistoryQuestHistoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  _service?: Maybe<_Service>;
  gachaDetails?: Maybe<GachaDetails>;
  leaderboard?: Maybe<Leaderboard>;
  mole?: Maybe<Mole>;
  owner?: Maybe<Owner>;
  quests: Array<Quest>;
};


export type QueryMoleArgs = {
  tokenId: Scalars['Int'];
};


export type QueryOwnerArgs = {
  address: Scalars['Address'];
};

export type Quest = {
  __typename?: 'Quest';
  symbol: Symbol;
};

export type QuestHistory = {
  __typename?: 'QuestHistory';
  completedAt: Scalars['DateTime'];
  earnedExp?: Maybe<Scalars['BigDecimal']>;
  symbol: Symbol;
};

export type QuestHistoryConnection = {
  __typename?: 'QuestHistoryConnection';
  edges: Array<QuestHistoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Long'];
};

export type QuestHistoryEdge = {
  __typename?: 'QuestHistoryEdge';
  cursor: Scalars['String'];
  node: QuestHistory;
};

export enum RankComparison {
  Equal = 'EQUAL',
  Higher = 'HIGHER',
  Lower = 'LOWER'
}

export enum Rarity {
  Common = 'COMMON',
  Epic = 'EPIC',
  Legendary = 'LEGENDARY',
  Rare = 'RARE',
  Special = 'SPECIAL'
}

export type RedeemGachaPayload = {
  __typename?: 'RedeemGachaPayload';
  exp?: Maybe<Scalars['Int']>;
  hasRedeemGacha?: Maybe<Scalars['Boolean']>;
  hp?: Maybe<Scalars['Int']>;
};

export type RefreshTokenInput = {
  accessToken: Scalars['String'];
  address: Scalars['Address'];
  refreshToken: Scalars['String'];
};

export type RefreshTokenPayload = {
  __typename?: 'RefreshTokenPayload';
  accessToken: Scalars['String'];
  address: Scalars['Address'];
  expiresAt?: Maybe<Scalars['Long']>;
  refreshToken: Scalars['String'];
};

export enum Symbol {
  Adopt = 'ADOPT',
  Barter = 'BARTER',
  Farm = 'FARM',
  Gacha = 'GACHA',
  GoldDigger = 'GOLD_DIGGER',
  Hydrate = 'HYDRATE',
  MoleDash = 'MOLE_DASH',
  MoleOpoly = 'MOLE_OPOLY',
  Profit = 'PROFIT',
  TeamUp = 'TEAM_UP'
}

export type UpdateMoleErrors = NameNotAvailable | NameTooLong | NameTooShort;

export type UpdateMoleInput = {
  name: Scalars['String'];
  owner: Scalars['Address'];
  tokenId: Scalars['Int'];
};

export type UpdateMolePayload = {
  __typename?: 'UpdateMolePayload';
  errors: Array<Maybe<UpdateMoleErrors>>;
};

export type UpdateTeamMembersInput = {
  owner: Scalars['Address'];
  tokenIds: Array<Scalars['Int']>;
};

export type UpdateTeamMembersPayload = {
  __typename?: 'UpdateTeamMembersPayload';
  isFirstUpdate?: Maybe<Scalars['Boolean']>;
};

export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String'];
};

export type LoginMutationVariables = Exact<{
  timestamp: Scalars['Long'];
  address: Scalars['Address'];
  signature: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginPayload', accessToken: string, address: any, expiresAt?: any | null, refreshToken: string } };

export type RefreshTokenMutationVariables = Exact<{
  accessToken: Scalars['String'];
  address: Scalars['Address'];
  refreshToken: Scalars['String'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'RefreshTokenPayload', accessToken: string, address: any, expiresAt?: any | null, refreshToken: string } };

export type CleanMutationVariables = Exact<{
  address: Scalars['Address'];
}>;


export type CleanMutation = { __typename?: 'Mutation', clean: { __typename?: 'CleanPayload', hasClean?: boolean | null } };

export type FeedFoodMutationVariables = Exact<{
  address: Scalars['Address'];
  foodType: FoodType;
  tokenIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type FeedFoodMutation = { __typename?: 'Mutation', feedFood: { __typename?: 'FeedFoodPayload', acceptFood?: boolean | null } };

export type GetGachaponDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGachaponDetailsQuery = { __typename?: 'Query', gachaDetails?: { __typename?: 'GachaDetails', startTime?: any | null, endTime?: any | null } | null };

export type RedeemGachaMutationVariables = Exact<{
  address: Scalars['Address'];
  type: GachaOption;
}>;


export type RedeemGachaMutation = { __typename?: 'Mutation', redeemGacha: { __typename?: 'RedeemGachaPayload', hasRedeemGacha?: boolean | null, exp?: number | null, hp?: number | null } };

export type GetGotchiOwnerQueryVariables = Exact<{
  address: Scalars['Address'];
}>;


export type GetGotchiOwnerQuery = { __typename?: 'Query', owner?: { __typename?: 'Owner', address: any, hasAdopted?: boolean | null, isOnboarded?: boolean | null, teamHealthPoint?: number | null, expMultiplier?: number | null, highestDailyExp?: any | null, todayExp?: any | null, todayQuestCount?: number | null, isClean?: boolean | null, nextDirtyDeclineTime?: any | null, moles?: Array<{ __typename?: 'Mole', tokenId: number, name?: string | null, imageUrl?: any | null, isEnlisted?: boolean | null, rarity?: Rarity | null, owner?: any | null, totalExp?: any | null, isStaked?: boolean | null, tier?: number | null, rank?: number | null, boost?: any | null, hasFedToday?: boolean | null, health?: number | null, isLocked?: boolean | null, unlockAt?: any | null } | null> | null, questHistory?: { __typename?: 'OwnerQuestHistory', totalEarnedExp?: any | null, questHistoryConnection?: { __typename?: 'QuestHistoryConnection', totalCount: any, edges: Array<{ __typename?: 'QuestHistoryEdge', cursor: string, node: { __typename?: 'QuestHistory', symbol: Symbol, earnedExp?: any | null, completedAt: any } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null, quests?: Array<{ __typename?: 'OwnerQuest', symbol: Symbol, exp?: any | null, isCompleted?: boolean | null }> | null, lockedMoles: Array<{ __typename?: 'LockedMole', tokenId?: number | null, unlockAt?: any | null }>, gachaInfo?: { __typename?: 'OwnerGachaInfo', isTeamFedToday?: boolean | null, isGachaEligible?: boolean | null, gachaRecordCount?: number | null, todayDifferentQuestCount?: number | null } | null, moleDashInfo?: { __typename?: 'OwnerMoleDashInfo', todayExp?: any | null, bestRecord?: { __typename?: 'MoleDashRecord', owner?: any | null, lifespan?: any | null, completedAt?: any | null } | null } | null } | null };

export type LeaderboardQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  filter: LeaderboardFilterInput;
}>;


export type LeaderboardQuery = { __typename?: 'Query', leaderboard?: { __typename?: 'Leaderboard', moles?: { __typename?: 'MoleConnection', totalCount: any, edges: Array<{ __typename?: 'MoleEdge', cursor: string, node: { __typename?: 'Mole', tokenId: number, name?: string | null, imageUrl?: any | null, isEnlisted?: boolean | null, rarity?: Rarity | null, owner?: any | null, totalExp?: any | null, isStaked?: boolean | null, tier?: number | null, rank?: number | null, boost?: any | null } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type GetMoleQueryVariables = Exact<{
  tokenId: Scalars['Int'];
}>;


export type GetMoleQuery = { __typename?: 'Query', mole?: { __typename?: 'Mole', tokenId: number, name?: string | null, imageUrl?: any | null, isEnlisted?: boolean | null, rarity?: Rarity | null, owner?: any | null, totalExp?: any | null, isStaked?: boolean | null, tier?: number | null, rank?: number | null, boost?: any | null, hasFedToday?: boolean | null, health?: number | null, isLocked?: boolean | null, unlockAt?: any | null } | null };

export type GainMoleDashExpMutationVariables = Exact<{
  address: Scalars['Address'];
  lasted: Scalars['Long'];
}>;


export type GainMoleDashExpMutation = { __typename?: 'Mutation', gainMoleDashExp: { __typename?: 'GainMoleDashExpPayload', gainedExp?: any | null } };

export type QuestHistoryQueryVariables = Exact<{
  address: Scalars['Address'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type QuestHistoryQuery = { __typename?: 'Query', owner?: { __typename?: 'Owner', address: any, questHistory?: { __typename?: 'OwnerQuestHistory', questHistoryConnection?: { __typename?: 'QuestHistoryConnection', totalCount: any, edges: Array<{ __typename?: 'QuestHistoryEdge', cursor: string, node: { __typename?: 'QuestHistory', symbol: Symbol, earnedExp?: any | null, completedAt: any } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null };

export type QuestsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestsQuery = { __typename?: 'Query', quests: Array<{ __typename?: 'Quest', symbol: Symbol }> };

export type UpdateTeamMembersMutationVariables = Exact<{
  owner: Scalars['Address'];
  tokenIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateTeamMembersMutation = { __typename?: 'Mutation', updateTeamMembers: { __typename?: 'UpdateTeamMembersPayload', isFirstUpdate?: boolean | null } };

export type UpdateMoleMutationVariables = Exact<{
  owner: Scalars['Address'];
  tokenId: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateMoleMutation = { __typename?: 'Mutation', updateMole: { __typename?: 'UpdateMolePayload', errors: Array<{ __typename?: 'NameNotAvailable', code: ErrorCode, message: string } | { __typename?: 'NameTooLong', code: ErrorCode, message: string } | { __typename?: 'NameTooShort', code: ErrorCode, message: string } | null> } };


export const LoginDocument = gql`
    mutation login($timestamp: Long!, $address: Address!, $signature: String!) {
  login(input: {timestamp: $timestamp, address: $address, signature: $signature}) {
    accessToken
    address
    expiresAt
    refreshToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      timestamp: // value for 'timestamp'
 *      address: // value for 'address'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken($accessToken: String!, $address: Address!, $refreshToken: String!) {
  refreshToken(
    input: {accessToken: $accessToken, address: $address, refreshToken: $refreshToken}
  ) {
    accessToken
    address
    expiresAt
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      address: // value for 'address'
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const CleanDocument = gql`
    mutation clean($address: Address!) {
  clean(address: $address) {
    hasClean
  }
}
    `;
export type CleanMutationFn = Apollo.MutationFunction<CleanMutation, CleanMutationVariables>;

/**
 * __useCleanMutation__
 *
 * To run a mutation, you first call `useCleanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCleanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cleanMutation, { data, loading, error }] = useCleanMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCleanMutation(baseOptions?: Apollo.MutationHookOptions<CleanMutation, CleanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CleanMutation, CleanMutationVariables>(CleanDocument, options);
      }
export type CleanMutationHookResult = ReturnType<typeof useCleanMutation>;
export type CleanMutationResult = Apollo.MutationResult<CleanMutation>;
export type CleanMutationOptions = Apollo.BaseMutationOptions<CleanMutation, CleanMutationVariables>;
export const FeedFoodDocument = gql`
    mutation feedFood($address: Address!, $foodType: FoodType!, $tokenIds: [Int!]!) {
  feedFood(input: {foodType: $foodType, owner: $address, tokenIds: $tokenIds}) {
    acceptFood
  }
}
    `;
export type FeedFoodMutationFn = Apollo.MutationFunction<FeedFoodMutation, FeedFoodMutationVariables>;

/**
 * __useFeedFoodMutation__
 *
 * To run a mutation, you first call `useFeedFoodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeedFoodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feedFoodMutation, { data, loading, error }] = useFeedFoodMutation({
 *   variables: {
 *      address: // value for 'address'
 *      foodType: // value for 'foodType'
 *      tokenIds: // value for 'tokenIds'
 *   },
 * });
 */
export function useFeedFoodMutation(baseOptions?: Apollo.MutationHookOptions<FeedFoodMutation, FeedFoodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeedFoodMutation, FeedFoodMutationVariables>(FeedFoodDocument, options);
      }
export type FeedFoodMutationHookResult = ReturnType<typeof useFeedFoodMutation>;
export type FeedFoodMutationResult = Apollo.MutationResult<FeedFoodMutation>;
export type FeedFoodMutationOptions = Apollo.BaseMutationOptions<FeedFoodMutation, FeedFoodMutationVariables>;
export const GetGachaponDetailsDocument = gql`
    query getGachaponDetails {
  gachaDetails {
    startTime
    endTime
  }
}
    `;

/**
 * __useGetGachaponDetailsQuery__
 *
 * To run a query within a React component, call `useGetGachaponDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGachaponDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGachaponDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGachaponDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetGachaponDetailsQuery, GetGachaponDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGachaponDetailsQuery, GetGachaponDetailsQueryVariables>(GetGachaponDetailsDocument, options);
      }
export function useGetGachaponDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGachaponDetailsQuery, GetGachaponDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGachaponDetailsQuery, GetGachaponDetailsQueryVariables>(GetGachaponDetailsDocument, options);
        }
export type GetGachaponDetailsQueryHookResult = ReturnType<typeof useGetGachaponDetailsQuery>;
export type GetGachaponDetailsLazyQueryHookResult = ReturnType<typeof useGetGachaponDetailsLazyQuery>;
export type GetGachaponDetailsQueryResult = Apollo.QueryResult<GetGachaponDetailsQuery, GetGachaponDetailsQueryVariables>;
export const RedeemGachaDocument = gql`
    mutation redeemGacha($address: Address!, $type: GachaOption!) {
  redeemGacha(address: $address, type: $type) {
    hasRedeemGacha
    exp
    hp
  }
}
    `;
export type RedeemGachaMutationFn = Apollo.MutationFunction<RedeemGachaMutation, RedeemGachaMutationVariables>;

/**
 * __useRedeemGachaMutation__
 *
 * To run a mutation, you first call `useRedeemGachaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemGachaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemGachaMutation, { data, loading, error }] = useRedeemGachaMutation({
 *   variables: {
 *      address: // value for 'address'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRedeemGachaMutation(baseOptions?: Apollo.MutationHookOptions<RedeemGachaMutation, RedeemGachaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemGachaMutation, RedeemGachaMutationVariables>(RedeemGachaDocument, options);
      }
export type RedeemGachaMutationHookResult = ReturnType<typeof useRedeemGachaMutation>;
export type RedeemGachaMutationResult = Apollo.MutationResult<RedeemGachaMutation>;
export type RedeemGachaMutationOptions = Apollo.BaseMutationOptions<RedeemGachaMutation, RedeemGachaMutationVariables>;
export const GetGotchiOwnerDocument = gql`
    query getGotchiOwner($address: Address!) {
  owner(address: $address) {
    address
    moles {
      tokenId
      name
      imageUrl
      isEnlisted
      rarity
      owner
      totalExp
      isStaked
      tier
      rank
      boost
      hasFedToday
      health
      isLocked
      unlockAt
    }
    hasAdopted
    isOnboarded
    teamHealthPoint
    expMultiplier
    highestDailyExp
    todayExp
    todayQuestCount
    isClean
    nextDirtyDeclineTime
    questHistory {
      questHistoryConnection(first: 10) {
        totalCount
        edges {
          node {
            symbol
            earnedExp
            completedAt
          }
          cursor
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
      }
      totalEarnedExp
    }
    quests {
      symbol
      exp
      isCompleted
    }
    lockedMoles {
      tokenId
      unlockAt
    }
    gachaInfo {
      isTeamFedToday
      isGachaEligible
      gachaRecordCount
      todayDifferentQuestCount
    }
    moleDashInfo {
      todayExp
      bestRecord {
        owner
        lifespan
        completedAt
      }
    }
  }
}
    `;

/**
 * __useGetGotchiOwnerQuery__
 *
 * To run a query within a React component, call `useGetGotchiOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGotchiOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGotchiOwnerQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetGotchiOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetGotchiOwnerQuery, GetGotchiOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGotchiOwnerQuery, GetGotchiOwnerQueryVariables>(GetGotchiOwnerDocument, options);
      }
export function useGetGotchiOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGotchiOwnerQuery, GetGotchiOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGotchiOwnerQuery, GetGotchiOwnerQueryVariables>(GetGotchiOwnerDocument, options);
        }
export type GetGotchiOwnerQueryHookResult = ReturnType<typeof useGetGotchiOwnerQuery>;
export type GetGotchiOwnerLazyQueryHookResult = ReturnType<typeof useGetGotchiOwnerLazyQuery>;
export type GetGotchiOwnerQueryResult = Apollo.QueryResult<GetGotchiOwnerQuery, GetGotchiOwnerQueryVariables>;
export const LeaderboardDocument = gql`
    query leaderboard($first: Int!, $after: String, $filter: LeaderboardFilterInput!) {
  leaderboard {
    moles(first: $first, after: $after, filter: $filter) {
      totalCount
      edges {
        node {
          tokenId
          name
          imageUrl
          isEnlisted
          rarity
          owner
          totalExp
          isStaked
          tier
          rank
          boost
        }
        cursor
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
}
    `;

/**
 * __useLeaderboardQuery__
 *
 * To run a query within a React component, call `useLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
      }
export function useLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
        }
export type LeaderboardQueryHookResult = ReturnType<typeof useLeaderboardQuery>;
export type LeaderboardLazyQueryHookResult = ReturnType<typeof useLeaderboardLazyQuery>;
export type LeaderboardQueryResult = Apollo.QueryResult<LeaderboardQuery, LeaderboardQueryVariables>;
export const GetMoleDocument = gql`
    query getMole($tokenId: Int!) {
  mole(tokenId: $tokenId) {
    tokenId
    name
    imageUrl
    isEnlisted
    rarity
    owner
    totalExp
    isStaked
    tier
    rank
    boost
    hasFedToday
    health
    isLocked
    unlockAt
  }
}
    `;

/**
 * __useGetMoleQuery__
 *
 * To run a query within a React component, call `useGetMoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoleQuery({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetMoleQuery(baseOptions: Apollo.QueryHookOptions<GetMoleQuery, GetMoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoleQuery, GetMoleQueryVariables>(GetMoleDocument, options);
      }
export function useGetMoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoleQuery, GetMoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoleQuery, GetMoleQueryVariables>(GetMoleDocument, options);
        }
export type GetMoleQueryHookResult = ReturnType<typeof useGetMoleQuery>;
export type GetMoleLazyQueryHookResult = ReturnType<typeof useGetMoleLazyQuery>;
export type GetMoleQueryResult = Apollo.QueryResult<GetMoleQuery, GetMoleQueryVariables>;
export const GainMoleDashExpDocument = gql`
    mutation gainMoleDashExp($address: Address!, $lasted: Long!) {
  gainMoleDashExp(input: {owner: $address, lifespan: $lasted}) {
    gainedExp
  }
}
    `;
export type GainMoleDashExpMutationFn = Apollo.MutationFunction<GainMoleDashExpMutation, GainMoleDashExpMutationVariables>;

/**
 * __useGainMoleDashExpMutation__
 *
 * To run a mutation, you first call `useGainMoleDashExpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGainMoleDashExpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gainMoleDashExpMutation, { data, loading, error }] = useGainMoleDashExpMutation({
 *   variables: {
 *      address: // value for 'address'
 *      lasted: // value for 'lasted'
 *   },
 * });
 */
export function useGainMoleDashExpMutation(baseOptions?: Apollo.MutationHookOptions<GainMoleDashExpMutation, GainMoleDashExpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GainMoleDashExpMutation, GainMoleDashExpMutationVariables>(GainMoleDashExpDocument, options);
      }
export type GainMoleDashExpMutationHookResult = ReturnType<typeof useGainMoleDashExpMutation>;
export type GainMoleDashExpMutationResult = Apollo.MutationResult<GainMoleDashExpMutation>;
export type GainMoleDashExpMutationOptions = Apollo.BaseMutationOptions<GainMoleDashExpMutation, GainMoleDashExpMutationVariables>;
export const QuestHistoryDocument = gql`
    query questHistory($address: Address!, $after: String, $first: Int = 10) {
  owner(address: $address) {
    address
    questHistory {
      questHistoryConnection(first: $first, after: $after) {
        totalCount
        edges {
          node {
            symbol
            earnedExp
            completedAt
          }
          cursor
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
}
    `;

/**
 * __useQuestHistoryQuery__
 *
 * To run a query within a React component, call `useQuestHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestHistoryQuery({
 *   variables: {
 *      address: // value for 'address'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useQuestHistoryQuery(baseOptions: Apollo.QueryHookOptions<QuestHistoryQuery, QuestHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestHistoryQuery, QuestHistoryQueryVariables>(QuestHistoryDocument, options);
      }
export function useQuestHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestHistoryQuery, QuestHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestHistoryQuery, QuestHistoryQueryVariables>(QuestHistoryDocument, options);
        }
export type QuestHistoryQueryHookResult = ReturnType<typeof useQuestHistoryQuery>;
export type QuestHistoryLazyQueryHookResult = ReturnType<typeof useQuestHistoryLazyQuery>;
export type QuestHistoryQueryResult = Apollo.QueryResult<QuestHistoryQuery, QuestHistoryQueryVariables>;
export const QuestsDocument = gql`
    query quests {
  quests {
    symbol
  }
}
    `;

/**
 * __useQuestsQuery__
 *
 * To run a query within a React component, call `useQuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuestsQuery(baseOptions?: Apollo.QueryHookOptions<QuestsQuery, QuestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestsQuery, QuestsQueryVariables>(QuestsDocument, options);
      }
export function useQuestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestsQuery, QuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestsQuery, QuestsQueryVariables>(QuestsDocument, options);
        }
export type QuestsQueryHookResult = ReturnType<typeof useQuestsQuery>;
export type QuestsLazyQueryHookResult = ReturnType<typeof useQuestsLazyQuery>;
export type QuestsQueryResult = Apollo.QueryResult<QuestsQuery, QuestsQueryVariables>;
export const UpdateTeamMembersDocument = gql`
    mutation updateTeamMembers($owner: Address!, $tokenIds: [Int!]!) {
  updateTeamMembers(input: {owner: $owner, tokenIds: $tokenIds}) {
    isFirstUpdate
  }
}
    `;
export type UpdateTeamMembersMutationFn = Apollo.MutationFunction<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>;

/**
 * __useUpdateTeamMembersMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMembersMutation, { data, loading, error }] = useUpdateTeamMembersMutation({
 *   variables: {
 *      owner: // value for 'owner'
 *      tokenIds: // value for 'tokenIds'
 *   },
 * });
 */
export function useUpdateTeamMembersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>(UpdateTeamMembersDocument, options);
      }
export type UpdateTeamMembersMutationHookResult = ReturnType<typeof useUpdateTeamMembersMutation>;
export type UpdateTeamMembersMutationResult = Apollo.MutationResult<UpdateTeamMembersMutation>;
export type UpdateTeamMembersMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>;
export const UpdateMoleDocument = gql`
    mutation updateMole($owner: Address!, $tokenId: Int!, $name: String!) {
  updateMole(input: {owner: $owner, tokenId: $tokenId, name: $name}) {
    errors {
      ... on IBaseError {
        code
        message
      }
    }
  }
}
    `;
export type UpdateMoleMutationFn = Apollo.MutationFunction<UpdateMoleMutation, UpdateMoleMutationVariables>;

/**
 * __useUpdateMoleMutation__
 *
 * To run a mutation, you first call `useUpdateMoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMoleMutation, { data, loading, error }] = useUpdateMoleMutation({
 *   variables: {
 *      owner: // value for 'owner'
 *      tokenId: // value for 'tokenId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateMoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMoleMutation, UpdateMoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMoleMutation, UpdateMoleMutationVariables>(UpdateMoleDocument, options);
      }
export type UpdateMoleMutationHookResult = ReturnType<typeof useUpdateMoleMutation>;
export type UpdateMoleMutationResult = Apollo.MutationResult<UpdateMoleMutation>;
export type UpdateMoleMutationOptions = Apollo.BaseMutationOptions<UpdateMoleMutation, UpdateMoleMutationVariables>;